<template>
  <div class="flex">
    <!-- <img class="img" src="../../assets/img/success.jpg" /> -->
    <!-- <div class="tips">
      Your order number is <span>{{ orderNo }}</span>
    </div> -->
    <!-- <img class="img" src="../../assets/img/success.jpg" /> -->
    <div>
      <div class="tips">🎉 Thank you for you order!</div>
      <div class="tips">
        You will receive a confirmation email with order details.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderNo: null,
    };
  },
  created() {
    this.orderNo = this.$route.query.orderNo
  }
};
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 160px;
}
.img {
  width: 100px;
  height: 100px;
  margin-bottom: 10px;
  margin-right: 20px;
}
.tips {
  color: black;
  font-size: 25px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/success.vue